import {apiCall} from "./apicall";

export async function getUsers() {
    return await apiCall("/users")
}

export async function getUser(id){
    return await apiCall("/user/"+id)
}

export async function getUserCards(id){
    return await apiCall(`/user/${id}/cards`, {method: "GET"});
}

export async function addCardToUser(UserID, CardID){
    return await apiCall(`/user/${UserID}/cards`, {method: "POST"}, {CardID});
}

export async function removeCardFromUser(UserID, CardID){
    return await apiCall(`/user/${UserID}/cards`, {method: "DELETE"}, {CardID});
}

export async function getUserLocations(UserID){
    return await apiCall(`/user/${UserID}/locations`, {method: "GET"});
}

export async function addLocationToUser(UserID, LocationID){
    return await apiCall(`/user/${UserID}/locations`, {method: "POST"}, {LocationID});
}

export async function removeLocationFromUser(UserID, LocationID){
    return await apiCall(`/user/${UserID}/locations`, {method: "DELETE"}, {LocationID});
}

export async function createUser(){
    return await apiCall("/user", {method: "POST"});
}

export async function deleteUser(id){
    return await apiCall("/user/"+id, {method: "DELETE"});
}

let roles = null
export async function getRoles(){
    if(roles)return roles
    const res = await apiCall("/user/roles", {method: "GET"});
    if(res.success){
        roles = res
    }
    return res
}

export async function updateUser(user){
    return await apiCall("/user/"+user.UserID, {method: "PUT"}, user);
}
